<div class="answer-point-row" [formGroup]="answerPointForm()">
  <div class="drag-handle" qaiDragHandle>
    <qai-icon kind="drag" [color]="readOnly() ? '#9E9E9E' : 'var(--fg-brand-primary)'" size="16px" />
  </div>

  <div class="row-fields">
    <div class="verb-text-group">
      <div class="verb-select-wrap">
        <qai-searchable-select
          [shape]="'rectangle'"
          [searchable]="false"
          [options]="verbOptions"
          [value]="verbValue"
          [disabled]="readOnly()"
          (valueChange)="onVerbChange($event)"
        />
      </div>

      <div class="display-text-wrap">
        <textarea
          qai-textarea
          autosize
          qaiTrimLeading
          qaiPasteClean
          rows="1"
          formControlName="displayText"
          [placeholder]="'simulationBuilder.KC_ANSWER_POINT_TEXT_PLACEHOLDER' | transloco"
        ></textarea>
      </div>
    </div>

    @if (customFeedbackExpanded()) {
      <qai-field
        [label]="'simulationBuilder.KC_ANSWER_POINT_CUSTOM_FEEDBACK_LABEL' | transloco"
        [description]="'simulationBuilder.KC_ANSWER_POINT_CUSTOM_FEEDBACK_HELPER' | transloco"
      >
        <textarea
          qai-textarea
          autosize
          qaiTrimLeading
          qaiPasteClean
          formControlName="displayFactIncorrect"
        ></textarea>
      </qai-field>
    } @else {
      <button
        type="button"
        class="custom-feedback-link"
        (click)="toggleCustomFeedback()"
      >
        {{ 'simulationBuilder.KC_ANSWER_POINT_CUSTOM_FEEDBACK' | transloco }}
      </button>
    }
  </div>

  <button type="button" class="delete-btn" (click)="handleDelete()" [disabled]="readOnly() || deleting()">
    <qai-icon kind="trash" [color]="readOnly() || deleting() ? '#9E9E9E' : 'var(--fg-brand-primary)'" size="16px" />
  </button>
</div>
